module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp1_6000.9441303f.png";